<template>
  <div class="content-v2">
    <div class="text-v2">
      <h3>{{ $t('common.structure') }}</h3>
      <p>{{ $t('about.structureIntro') }}</p>
    </div>
    <div class="org-grid-v2" v-if="orgList.length">
      <div class="org-card" v-for="item in orgList" :key="item.nodeId">
        <h4>{{ item.nodeName }}</h4>
        <p v-if="item.leader">{{ $t('common.leader') }}：{{ item.leader }}</p>
        <p v-if="item.phone">{{ $t('common.phone') }}：{{ item.phone }}</p>
      </div>
    </div>
    <div class="structure-img" v-else>
      <img src="@/assets/images/banner1.svg" alt="组织架构图" />
    </div>
  </div>
</template>

<script>
import { getOrgList } from '@/api/portal'

export default {
  name: 'AboutStructureV2',
  data() {
    return {
      orgList: []
    }
  },
  created() {
    getOrgList().then(list => {
      this.orgList = list || []
    }).catch(() => {})
  }
}
</script>

<style lang="scss" scoped>
.text-v2 {
  h3 {
    font-size: 24px;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 24px;
  }
  p {
    text-indent: 2em;
    font-size: 17px;
    line-height: 2.2;
    margin-bottom: 20px;
    color: #475569;
  }
}
.structure-img {
  margin-top: 40px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0,0,0,0.08);
  img {
    width: 100%;
    display: block;
  }
}

.org-grid-v2 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 36px;
}

.org-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 26px;
  box-shadow: 0 6px 24px rgba(15,23,42,0.04);

  h4 {
    font-size: 18px;
    color: #0f172a;
    margin-bottom: 12px;
  }

  p {
    font-size: 14px;
    color: #64748b;
    line-height: 1.8;
  }
}

@media (max-width: 960px) {
  .org-grid-v2 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .org-grid-v2 {
    grid-template-columns: 1fr;
  }
}
</style>
